var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"premainloader d-flex flex-column justify-content-center align-items-center"},[(_vm.logo)?_c('img',{attrs:{"alt":"Logo","src":_vm.logo,"width":"100"}}):_vm._e(),_c('div',{staticClass:"spinner mt-3",class:_vm.spinnerClass || 'spinner-primary'})])
}
var staticRenderFns = []

export { render, staticRenderFns }